<div class="col-xs-12">
  <div class="ibox float-e-margins">
    <div class="ibox-title">
      Filtros
    </div>
    <div class="ibox-content">
      <form>
        <div class="row">
          <div class="col-lg-4 col-xs-12">
            <label for="descricao">Descrição</label>
            <input class="form-control" ng-model="filters.descricao" type="text" id="descricao" name="descricao" autofocus>
          </div>

          <div class="col-lg-3 col-xs-12">
            <label>Tipo</label>
            <ui-select ng-model="filters.tipo" theme="bootstrap">
              <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao | capitalize}}</ui-select-match>
              <ui-select-choices repeat="tipo in tiposDeOcorrencia | filter: $select.search">
                <span class="form-group" ng-bind-html="tipo.descricao | capitalize | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>
          <div class="col-lg-3 col-xs-12">
            <label>Exibir</label>
            <select name="exibir" id="exibir" class="form-control" ng-model="filters.exibir">
              <option value="all">Todos</option>
              <option value="ativos">Apenas ativos</option>
              <option value="inativos">Apenas inativos</option>
            </select>
          </div>
          <div class="col-lg-2 col-xs-12 text-center">
            <label>&nbsp;</label><br>
            <button class="btn btn-success btn-sm" ng-click="buscarClick()">
              Buscar <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
